import React from "react";

export default function CategoryNav({ categories, selectedCategory, handleCategoryClick, scrollLeft, scrollRight, headerHeight }) {
  return (
    <div className="menu-sticky-nav" style={{ top: `${headerHeight}px` }}>
      <div className="menu-nav-inner">
        <button className="menu-nav-arrow left" onClick={scrollLeft}>&lt;</button>
        <div className="menu-nav">
          <div className="menu-category-pills" role="tablist" aria-label="Menu categories">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`menu-pill ${selectedCategory === cat ? "active" : ""}`}
                onClick={() => handleCategoryClick(cat)}
                aria-pressed={selectedCategory === cat}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
        <button className="menu-nav-arrow right" onClick={scrollRight}>&gt;</button>
      </div>
    </div>
  );
}
